module.exports = __webpack_public_path__ + "img/2.a8f30c57.svg";